module.exports = __webpack_public_path__ + "img/redux.cc81d97b.svg";